if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      // Guardamos siempre el opener de forma segura
      if (opener) {
        this.openedBy = opener;
      }
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      // Si no hay opener, no hacemos nada para no romper el JS
      if (!this.openedBy) return;

      const mediaId = this.openedBy.getAttribute('data-media-id');
      if (!mediaId) return;

      // Desactivar todos los media menos el actual
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`)
        .forEach((element) => {
          element.classList.remove('active');
        });

      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      // Centrar horizontalmente si existe el contenedor
      const container = this.querySelector('[role="document"]');
      if (container) {
        const mediaWidth = activeMedia.offsetWidth || activeMedia.clientWidth || 0;
        if (mediaWidth > 0) {
          container.scrollLeft = Math.max(
            0,
            (mediaWidth - container.clientWidth) / 2
          );
        }
      }

      // Reproducir vídeo si es diferido
      if (activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  });
}
